export class VendorContactRoleEntity {
  id: number;
  name_En: string;
  name_Fr: string;

  constructor(entity?: VendorContactRoleEntity) {
    if (entity) {
      Object.assign(this, { ...entity });
    } else {
      this.id = 0;
      this.name_En = '';
      this.name_Fr = '';
    }
  }
}
